import { apiURL, axiosInstance } from 'constants/config';
import {
  loadHolidaysSuccess,
  loadHolidaysFail,
  loadHolidaysRequested,
  storeHolidayRequested,
  storeHolidaySuccess,
  storeHolidayFail,
  storeBranchHolidayRequested,
  storeBranchHolidaySuccess,
  storeBranchHolidayFail,
  updateHolidayRequested,
  updateHolidaySuccess,
  updateHolidayFail,
  deleteHolidayRequested,
  deleteHolidaySuccess,
  deleteHolidayFail,
  deleteBranchHolidayRequested,
  deleteBranchHolidaySuccess,
  deleteBranchHolidayFail,
} from './holidaySlice';
import { put, call, takeEvery } from 'redux-saga/effects';
import toast from 'react-hot-toast';
import { loadCustomerEffect } from 'store/customers/sagas';
import { loadBranchEffect } from 'store/branch/sagas';

export function* loadHolidaysEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/holidays/users/${
        action.payload?.filters?.reference ?? ''
      }?SearchValue=${
        action?.payload?.filters?.query ?? ''
      }&PaginationOption.Page=${
        action?.payload?.page
      }&PaginationOption.PageSize=${action.payload?.perPage}`
    );
    yield put(loadHolidaysSuccess(data));
  } catch (error: any) {
    yield put(loadHolidaysFail(error.meessage));
  }
}

export function* storeHolidayEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/holidays`,
      action.payload
    );

    if (data?.succeeded) {
      yield put(storeHolidaySuccess(data));
      yield call(loadCustomerEffect, {
        payload: { reference: action?.payload?.customerReference },
        type: '',
      });
      yield call(loadHolidaysEffect, {
        payload: {
          filters: { reference: data?.result, query: '' },
          page: 1,
          perPage: 10,
        },
        type: '',
      });
      toast.success('Holiday created successfully');
    } else {
      toast.error('Holiday create failed! ', data?.errors);
    }
  } catch (error: any) {
    yield put(storeHolidayFail(error.message));
  }
}

export function* storeBranchHolidayEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/holidays`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(storeBranchHolidaySuccess(data));
      yield call(loadBranchEffect, {
        payload: action.payload?.ref,
        type: '',
      });

      toast.success('Holiday created successfully');
    } else {
      toast.error('Holiday create failed! ', data?.errors);
    }
  } catch (error: any) {
    yield put(storeBranchHolidayFail(error.message));
  }
}

export function* updateHolidayEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.put,
      `${apiURL}/holidays/${action.payload?.id}`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(updateHolidaySuccess(data));

      yield call(loadHolidaysEffect, {
        payload: {
          filters: { reference: data?.result, query: '' },
          page: 1,
          perPage: 10,
        },
        type: '',
      });

      toast.success('Holiday updated successfully');
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(updateHolidayFail(error.message));
  }
}

export function* deleteHolidayEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.delete,
      `${apiURL}/holidays/${action.payload?.item?.id}`,
      action.payload?.item
    );

    if (data?.succeeded) {
      yield put(deleteHolidaySuccess(data));
      yield call(loadHolidaysEffect, {
        payload: {
          filters: {
            reference: action?.payload?.item?.customerReference,
            query: '',
          },
          page: 1,
          perPage: 10,
        },
        type: '',
      });

      toast.success('Holiday deleted successfully');
    }
  } catch (error: any) {
    yield put(deleteHolidayFail(error.message));
  }
}

export function* deleteBranchHolidayEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.delete,
      `${apiURL}/holidays/${action.payload?.id}`
    );

    if (data?.succeeded) {
      yield put(deleteBranchHolidaySuccess(data));
      yield call(loadBranchEffect, {
        payload: action.payload?.ref,
        type: '',
      });

      toast.success('Holiday deleted successfully');
    }
  } catch (error: any) {
    yield put(deleteBranchHolidaySuccess(error.message));
  }
}

export function* holidaysSaga(): Generator<any, void, any> {
  yield takeEvery(storeHolidayRequested, storeHolidayEffect);
  yield takeEvery(storeBranchHolidayRequested, storeBranchHolidayEffect);
  yield takeEvery(loadHolidaysRequested, loadHolidaysEffect);
  yield takeEvery(updateHolidayRequested, updateHolidayEffect);
  yield takeEvery(deleteHolidayRequested, deleteHolidayEffect);
  yield takeEvery(deleteBranchHolidayRequested, deleteBranchHolidayEffect);
}
